import { FormEvent, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { articles as allArticles } from "@/mocks/articles";
import { searchArticles } from "@/lib/content";

export default function HeroSection() {
  const navigate = useNavigate();
  const [kw, setKw] = useState("");
  const results = kw.trim() ? searchArticles(kw).slice(0, 5) : [];

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (results[0]) {
      navigate(`/article/${results[0].id}`);
    }
  };

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20abstract%20editorial%20banner%20of%20flowing%20coral%20red%20and%20golden%20amber%20organic%20shapes%20over%20warm%20cream%20paper%20texture%2C%20soft%20grain%2C%20dynamic%20wide%20composition%2C%20artistic%20gradient%20waves%2C%20no%20text&width=1800&height=1000&seq=hero-chigua-2026&orientation=landscape"
          alt="51吃瓜今日新鲜瓜热点背景"
          title="51吃瓜今日新鲜瓜 - 实时更新"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/65 to-foreground-950/80"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 pt-32 md:pt-40 pb-16 md:pb-24">
        <div className="max-w-content mx-auto">
          <div className="max-w-3xl fade-up">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/15 text-background-50 text-xs border border-background-50/25">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-400"></span>
              每日更新 · 热门事件实时同步
            </span>
            <h1 className="mt-6 font-heading font-black text-4xl md:text-6xl text-background-50 leading-tight">
              今天有什么瓜，
              <br className="hidden md:block" />
              一搜便知
            </h1>
            <p className="mt-5 text-base md:text-lg text-background-100/85 leading-relaxed max-w-2xl">
              51吃瓜聚合全网娱乐热点，新瓜推荐、定时开吃、瓜田分类一站看齐。吃瓜群众不迷路，最新动态随时掌握。
            </p>

            <form onSubmit={onSubmit} className="mt-8 max-w-xl">
              <div className="flex flex-col sm:flex-row gap-2 p-2 rounded-full bg-background-50/95">
                <div className="flex items-center gap-2 flex-1 px-4 py-2">
                  <i className="ri-search-2-line text-foreground-400 text-lg"></i>
                  <input
                    value={kw}
                    onChange={(e) => setKw(e.target.value)}
                    placeholder="试试搜索：新专辑 / 点映 / Livehouse"
                    className="flex-1 bg-transparent border-none outline-none text-sm text-foreground-900 placeholder:text-foreground-400"
                  />
                </div>
                <button
                  type="submit"
                  className="px-6 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  搜一搜
                </button>
              </div>
              {results.length > 0 && (
                <ul className="mt-2 rounded-lg bg-background-50/95 border border-background-200 overflow-hidden divide-y divide-background-200">
                  {results.map((item) => (
                    <li key={item.id}>
                      <Link
                        to={`/article/${item.id}`}
                        className="block px-4 py-2.5 text-sm text-foreground-800 hover:bg-primary-50 transition-colors line-clamp-1"
                      >
                        {item.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </form>

            <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3 text-sm text-background-100/80">
              <span className="flex items-center gap-1.5">
                <i className="ri-flashlight-line text-accent-400"></i>
                今日更新 {allArticles.length} 条新瓜
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-group-line text-accent-400"></i>
                6 大瓜田分类
              </span>
            </div>
          </div>

          <div className="mt-10 flex flex-wrap gap-2">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full bg-background-50/10 border border-background-50/25 text-background-50 text-xs md:text-sm hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className={`${cat.emoji} text-accent-400`}></i>
                {cat.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}